import React from "react";

const dot = () => <div className="dot" />;

export default dot;
